import { getColIndex } from '@components/bid_request/details/utils/getColIndex';
import { LineItemTableColumnSettings } from '@components/bid_request/details/types';
import { NEGOTIATION_STARTING_PRICE_COLUMN_KEY } from '@components/bid_request/details/constants';

// Column index for id === 'price', from the same columnSettings array passed to Handsontable.
export const getPriceColIdx = (columnSettings: LineItemTableColumnSettings[]): number => (
  getColIndex({ columnSettings, headerId: 'price' })
);

// Column index for the Negotiation Starting Price column. The split layout names it
// `negotiation_starting_price` (editable); the non-split layout names it `nsb_benchmark` (read-only,
// SB display + flavor link). Match either so the picker/modal Apply resolves the column in both.
export const getNegotiationColIdx = (columnSettings: LineItemTableColumnSettings[]): number => {
  const negotiationIdx = getColIndex({ columnSettings, headerId: NEGOTIATION_STARTING_PRICE_COLUMN_KEY });
  return negotiationIdx >= 0 ? negotiationIdx : getColIndex({ columnSettings, headerId: 'nsb_benchmark' });
};
